import api from "@/service/api";

const state = () => ({
    verified: false,
    pendingReview: false,
})

const mutations = {
    setStatus(state, { verified, pendingReview }) {
        state.verified = verified;
        state.pendingReview = pendingReview;
    },
}

const actions = {
    refresh({ commit, dispatch }) {
        return api.post("/userLiveness/status").then((response) => {
            commit("setStatus", {
                verified: response?.data?.verified ?? false,
                pendingReview: response?.data?.pendingReview ?? false,
            });

            if (response?.data?.verified) {
                dispatch("onboarding/status", null, { root: true });
            }
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}
